import { useBaseHost } from '@ms/yammer-hooks/dist/session';
import { reportUsage } from '@ms/yammer-telemetry';
import type { FC, PropsWithChildren } from 'react';
import React, { memo } from 'react';

import SessionContextProvider from './SessionContextProvider';
import { renderGroupHoverCard, renderUserHoverCard } from './renderer';

const SessionContextProviderWithHooks: FC<PropsWithChildren> = memo(({ children }) => {
  const baseHost = useBaseHost();

  return (
    <SessionContextProvider
      baseHost={baseHost}
      renderGroupReference={renderGroupHoverCard}
      renderUserReference={renderUserHoverCard}
      reportUsage={reportUsage}
    >
      {children}
    </SessionContextProvider>
  );
});

export default SessionContextProviderWithHooks;
